import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { switchWorkspaceService } from 'services/authService';
import { useTranslation } from 'react-i18next';
import Loader from 'components/Common/loader';

const WorkspaceSwitcher = () => {
    const { workSpaces, user } = useSelector((state: any) => state.authSlice);
    const [switching, setSwitching] = useState<string | null>(null);
    const [currentInstanceId, setCurrentInstanceId] = useState(user?.instanceId);
    const { t } = useTranslation();
    const handleSwitchWorkspace = async (workspace: any) => {
        if (workspace.id === currentInstanceId) return;

        setSwitching(workspace.id);
        try {
            await switchWorkspaceService(workspace.id);
            setCurrentInstanceId(workspace.id);
            // window.location.reload();
        } catch (error) {
            console.error('Failed to switch workspace:', error);
        } finally {
            setSwitching(null);
        }
    };

    // Find current workspace
    const currentWorkspace = useMemo(() => workSpaces?.find((workspace: any) => String(workspace.id) === String(currentInstanceId)), [workSpaces, currentInstanceId]);

    if (!currentWorkspace || !workSpaces || !user || workSpaces?.length <= 1) {
        return null;
    }
    return (
        <div className="dropdown me-2">
            <div className="pe-1 ms-1">
                <Link
                    to="#"
                    className="btn btn-outline-light fw-normal bg-white d-flex align-items-center p-2"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    {/* <i className="ti ti-building-community me-1" /> */}
                    <img
                        src={currentWorkspace?.logo || "/assets/img/profiles/fake-image-instance.jpg"}
                        className="avatar avatar-sm rounded me-2"
                        alt={currentWorkspace?.name}
                        onError={(e) => {
                            e.currentTarget.src = "/assets/img/profiles/fake-image-instance.jpg";
                        }}
                    />
                    {currentWorkspace?.name || "Workspace"}
                </Link>
                <div className="dropdown-menu dropdown-menu-right" style={{ minWidth: '270px' }}>
                    <div className="px-3 py-2 border-bottom">
                        <small className="text-muted">{t("switch_workspace")}</small>
                    </div>

                    {workSpaces?.length > 0 ? (
                        workSpaces.map((workspace: any) => (
                            <div
                                key={workspace.id}
                                className={`dropdown-item d-flex align-items-center py-2 ${workspace.id === currentInstanceId ? "active" : ""
                                    }`}
                                onClick={() => handleSwitchWorkspace(workspace)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="d-flex align-items-center w-100">
                                    <div className="me-3">
                                        <img
                                            src={workspace.logo || "/assets/img/profiles/fake-image-instance.jpg"}
                                            className="avatar avatar-sm rounded"
                                            alt={workspace.name}
                                            onError={(e) => {
                                                e.currentTarget.src = "/assets/img/profiles/fake-image-instance.jpg";
                                            }}
                                        />
                                    </div>

                                    <div className="flex-grow-1">
                                        <div className="d-flex align-items-center">
                                            <span className="fw-medium">{workspace.name}</span>
                                            {workspace.id === currentInstanceId && (
                                                <span className="badge bg-primary ms-2">{t("current")}</span>
                                            )}
                                        </div>
                                        {workspace.description && (
                                            <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>
                                                {workspace.description}
                                            </small>
                                        )}
                                    </div>

                                    <div className="ms-2">
                                        {switching === workspace.id ? (
                                            <Loader />
                                        ) : (
                                            <i className={`ti ti-arrow-right ${workspace.id === currentInstanceId ? 'text-white' : 'text-muted'
                                                }`} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="dropdown-item text-center text-muted py-3">
                            <i className="ti ti-building-community ti-lg mb-2 d-block"></i>
                            <small>{t("no_workspaces")}</small>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WorkspaceSwitcher;